import { getApiDocs } from 'lib/api'
import { useEffect, useState } from 'react'
import { useParams } from 'react-router-dom'
import { NotFound } from './NotFound'

type LoadState = { status: 'loading' } | { status: 'loaded'; url: string } | { status: 'notFound' }

export const ApiDocs = (): JSX.Element => {
  const { version } = useParams<{ version: string }>()
  const [state, setState] = useState<LoadState>({ status: 'loading' })

  useEffect(() => {
    let cancelled = false

    getApiDocs(version ?? '')
      .then((html) => {
        if (!cancelled)
          setState({
            status: 'loaded',
            url: URL.createObjectURL(new Blob([html], { type: 'text/html' })),
          })
      })
      .catch(() => {
        if (!cancelled) setState({ status: 'notFound' })
      })

    return () => {
      cancelled = true
    }
  }, [version])

  if (state.status === 'loading') {
    return <div>Loading…</div>
  }

  if (state.status === 'notFound') {
    return <NotFound />
  }

  // The docs are a self-contained HTML document rendered by an inline script, so it needs a
  // real document of its own (scripts injected via innerHTML never execute).
  return (
    <iframe
      title="API documentation"
      src={state.url}
      style={{ display: 'block', border: 0, width: '100%', height: '100vh' }}
    />
  )
}
